import { TmdxResourceCard } from '@features/components/ResourceCards';
import { ResourceLogisticsStatus } from '@/api/apis/case';
import { RESOURCE_STATUS_TEXT_MAP } from '@/constants/resources.constants';

type CrewMemberCardProps = {
  title: string;
  subTitle: string;
  showChip?: boolean;
  status?: ResourceLogisticsStatus;
};

export const CrewMemberCard = ({ title, subTitle, status, showChip }: CrewMemberCardProps) => {
  const statusText = status ? RESOURCE_STATUS_TEXT_MAP[status] || '' : '';
  return (
    <TmdxResourceCard
      size="sm"
      label="Actions"
      list={[]}
      type="user"
      title={title}
      subTitle={subTitle}
      isReadOnly
      menuDisabled
      cardClassNames="min-w-full"
      showChip={showChip}
      chipProps={{
        status,
      }}
      chipText={statusText}
      avatarProps={{
        type: 'user',
      }}
    />
  );
};
